<ng-template #downloadCentreForm role="document" let-modal>
  <div class="modal-header custom-suresim-header p-3 justify-content-center position-relative">
    <i class="text-white position-absolute start-0 top-50 translate-middle-y ms-3 fs-4"
      [ngClass]="showSureSimLogo ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
      (click)="onArrowClicked()"
      style="cursor: pointer;"
    ></i>
    <h4 class="modal-title text-white fs-4" id="formTitle">{{formTitle}}</h4>
    <button 
      type="button" 
      class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-3"
      data-bs-dismiss="modal" 
      aria-label="Close" 
      id="close-modal" 
      (click)="thisFormCancel()">
    </button>
  </div>

  @if (showSureSimLogo) {
    <div class="row custom-suresim-header">
      <div class="col-lg-12">
        <div class="text-center mt-2 mb-1 text-white-50 position-relative" style="top: -10px;">
          <div>
            @if (!curUser.branded || curUser.isUtelize) {
              <a class="d-inline-block auth-logo">
                <img
                  alt=""
                  [height]="isPlatformModeInview ? 120 : 90"
                  [src]="isPlatformModeInview ? 'assets/images/myinview-logo-text-right.png' : 'assets/images/SureSIM-Logo-Light-400.png'"
                >
              </a>
            }
          </div>
          <p class="mt-3 fs-15 fw-medium text-white">{{appTitle}}</p>
        </div>
      </div>
    </div>
  }

  <div class="modal-body">
    <form (ngSubmit)="thisFormSubmit()" [formGroup]="thisForm" class="tablelist-form" autocomplete="off">
      <!--
      <div class="downloads-bg-position downloads-bg" id="auth-particles">
        <div class="bg-overlay"></div>
      </div>
      -->
      <div class="row">
        <div class="col-12">
          <div class="mt-0 mb-0">
            <label class="form-label text-right"></label>
            <div class="alert border-0 {{alertColourProgress}} text-center" role="alert" style="margin-top: -30px;">
              <strong>Information</strong> - <span [innerHtml]="progressInformation" ></span>
            </div>
          </div>
        </div>
      </div>
      
      <div *ngFor="let category of downloadCategories" class="border border-success rounded px-2 pt-2 pb-2 mb-4">
        <div class="row mb-0">
          <div class="col-12">
            <div class="alert border-0 alert-primary mb-0 text-center" role="alert">
              <i class="position-absolute end-0 top-50 translate-middle-y fs-5"
                [ngClass]="categoryVisibility[category] ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                (click)="toggleCategoryVisibility(category)"
                style="cursor: pointer; color: #198754; margin-right: 12px;"
              ></i>
              <strong class="fs-5">
                {{ category }}
                <span
                  class="badge text-dark me-3 position-absolute start-0 top-50 translate-middle-y ms-3"
                  style="background-color: #E6FAF7;"
                >
                  {{ groupedDownloadFiles[category].length }} @if(groupedDownloadFiles[category].length==1) {document} @else {documents}
                </span>
              </strong>
            </div>
          </div>
        </div>
        <ng-container *ngIf="categoryVisibility[category]">
          <div class="row justify-content-center mt-3 mb-0 pb-0" #categoryContainer [attr.data-category]="category"></div>
        </ng-container>
      </div>

    </form>
  </div>
  
  <div class="modal-footer custom-footer d-flex justify-content-between align-items-center w-100 py-2 position-relative">
    <div class="position-absolute start-50 translate-middle-x text-center" style="pointer-events: none;">
      <p class="mb-0 text-white">
        <span>&copy;</span> {{year}} {{ourCompanyName}}
      </p>
    </div>
  
    <button
      type="button"
      class="btn btn-light ms-auto"
      data-bs-dismiss="modal"
      (click)="thisFormCancel()">
      Close
    </button>
  </div>
</ng-template>

<app-completed-modal-form #completedModalForm
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
